import { render, staticRenderFns } from "./Bubbles.vue?vue&type=template&id=409b908e&"
import script from "./Bubbles.vue?vue&type=script&lang=js&"
export * from "./Bubbles.vue?vue&type=script&lang=js&"
import style0 from "./Bubbles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports